export const useAboutUsApi = () => useApi<AboutUs>('/about-us')
export const useAboutUsPreviewApi = () => useBOFApi<AboutUs>('/about-us-preview')
